import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { isEmpty } from 'lodash';
import React from 'react';
export enum fieldType {
	'text',
	'select', //autocomplete
	'selectBox',
	'radio',
	'datePicker',
	'textArea',
	'dateRangePicker',
	'file',
	'checkbox',
	'custom',
	'label',
}

export enum customValueTypes {
	'integer',
}

export enum fieldMode {
	readonly = 'readonly',
	readWithEnableWrite = 'readWithEnableWrite',
	write = 'write',
}
// for select use options
export interface option {
	value: string;
	label: string;
	disabled?: boolean;
}

export interface fieldProps {
	name: string;
	value?: string | number | boolean | null | Record<string, any>;
	defaultValue?: string | number;
	options?: Array<option>;
	error?: boolean;
	helperText?: string;
	placeholder?: string;
	label?: string;
	required?: boolean;
	//handleChange?: any;
	disabled?: boolean;
	type?: string;
	autoselect?: string;
	sx?: any;
	regex?: any;
	readonly?: boolean;
	customComponent?: React.FC<any>;
	customData?: any;
	onClick?: (value: any) => void;
	isInFuture?: boolean;
	flex?: fieldsGroupType;
	maxLength?: number;
	minLength?: number;
}

export enum validationTypes {
	requierd = 'requierd',
	duplicatefields = 'duplicate',
	email = 'email',
	phone = 'phone',
	match = 'match',
	digitsOnly = 'digitsOnly',
	latinLettersHyphensDigits = 'latinLettersHyphensDigits',
	lettersOnly = 'lettersOnly',
	latinLettersOnly = 'latinLettersOnly',
	latinLettersSpecialChars = 'latinLettersSpecialChars',
	addressEnglish = 'addressEnglish', //english letters and numbers
	addressHebrew = 'addressHebrew', //hebrew letters and numbers
	address = 'address', //letters and numbers
	hebrewLettersOnly = 'hebrewLettersOnly',
	hebrewLettersSpecialChars = 'hebrewLettersSpecialChars',
	hebrewLettersAndDigits = 'hebrewLettersAndDigits',
	integer = 'integer', //valid number
	maxNumber = 'maxNumber',
	minNumber = 'minNumber',
	exceedsBalance = 'exceedsBalance',
	id = 'id',
	balance = 'balance',
	checked = 'checked',
	custom = 'custom',
	limitChars = 'limitChars',
	noDecimalAllowed = 'noDecimalAllowed',
}
export enum fieldsGroupType {
	row = 'row',
	col = 'column',
}

export enum fieldDependencyType {
	regex = 'regex',
	equals = 'equals',
	notEquals = 'notEquals',
	isEmpty = 'isEmpty',
	isCustomDependency = 'isCustomDependency',
}

export enum formThemes {
	hiddenInputs = 'hiddenInputs',
	regular = 'regular',
}

export interface fieldsGroup {
	type: fieldsGroupType;
	title?: string;
	styleObj?: object;
	spacing?: number;
	fields: field[];
}

export type fieldValidations = { [key in validationTypes]?: any }[];
export interface field {
	type: fieldType;
	dependency?: { name: string; value: any; type?: fieldDependencyType; custom?: (record: any) => void };
	dependencyAction?: dependencyAction;
	props: fieldProps;
	validation?: fieldValidations;
	styleObj?: object;
	valueProperty?: string;
	labelProperty?: string;
	renderOption?: (props: any, value: any) => void;
	renderInput?: any;
	getOptionDisabled?: any;
	ListboxProps?: object;
	maxValue?: number;
	mode?: fieldMode;
	suffix?: string;
	customValue?: (value: any, record?: Record<string, any>) => void;
	customValueType?: customValueTypes;
	isInFuture?: boolean;
	handleClick?: any;
}
export const ignoreHiddenInputsTypes = [fieldType.file, fieldType.checkbox];

export interface createFormProps {
	initialValidation?: { [key: string]: validationProps };
	name: string;
	handleChange: any;
	fieldsGroups: fieldsGroup[];
	values?: Record<string, any>;
	translation?: any;
	theme?: formThemes;
	checkInitValidation?: boolean;
	hide?: boolean;
	isInFuture?: boolean;
	emptyFormWhenValuesEmpty?: boolean;
	cardStyle?: object;
	isRequireValidate?: boolean;
}

export type validationProps = {
	name: string;
	valid: boolean;
	errorText: string | string[];
};

export type invalidFields = { [key: string]: validationProps };

export type customComponentInternalProps = {
	valid: boolean;
	cField: field;
	handleChange: any;
	customData?: any;
	label?: string;
	text?: string;
	handleClick?: any;
	disabled?: boolean;
	styleObj?: any;
};

export enum dependencyAction {
	none = 'none',
	hide = 'hide',
	disable = 'disable',
}
